import { useEffect, useState } from "react";

// LDF: Wie soll das grüne Mikrofon arbeiten? Einstellung pro Gerät.
// „whisper“: Sprachnachricht, verschriftlicht auf dem Mac mini (genauer, Aufnahme bleibt abspielbar)
// „geraet“: Live-Diktat mit der Spracherkennung von Apple/Google (Text erscheint sofort, keine Aufnahme)
export type VoiceMode = "whisper" | "geraet";

const KEY = "ldf.voice-mode";
const EVENT = "ldf:voice-mode";

const read = (): VoiceMode => {
  try {
    return localStorage.getItem(KEY) === "geraet" ? "geraet" : "whisper";
  } catch {
    return "whisper";
  }
};

export const useVoiceMode = () => {
  const [mode, setModeState] = useState<VoiceMode>(read);
  useEffect(() => {
    const sync = () => setModeState(read());
    window.addEventListener(EVENT, sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener(EVENT, sync);
      window.removeEventListener("storage", sync);
    };
  }, []);
  const setMode = (value: VoiceMode) => {
    try {
      localStorage.setItem(KEY, value);
    } catch {
      // Speicher nicht verfügbar
    }
    setModeState(value);
    window.dispatchEvent(new Event(EVENT));
  };
  return [mode, setMode] as const;
};

export const VoiceModeSwitch = ({ className }: { className?: string }) => {
  const [mode, setMode] = useVoiceMode();
  const option = (value: VoiceMode, label: string, hint: string) => (
    <button
      type="button"
      onClick={() => setMode(value)}
      title={hint}
      aria-pressed={mode === value}
      className={`rounded-full px-2.5 py-0.5 text-xs cursor-pointer ${mode === value ? "bg-background font-medium shadow-sm" : "text-muted-foreground"}`}
    >
      {label}
    </button>
  );
  return (
    <span className={`inline-flex gap-0.5 rounded-full bg-muted p-0.5 ${className ?? ""}`}>
      {option("whisper", "Mac mini", "Sprachnachricht – genauer, Aufnahme bleibt abspielbar, Text nach einigen Sekunden")}
      {option("geraet", "Live", "Live-Diktat mit der Spracherkennung des Geräts – Text erscheint sofort, keine Aufnahme")}
    </span>
  );
};
